import Joi from "@hapi/joi";

export const validCountries = [
  {
    name: "Nigeria",
    code: "NG",
    dialCode: "+234",
    flag: "🇳🇬",
  },
  {
    name: "Kenya",
    code: "KE",
    dialCode: "+254",
    flag: "🇰🇪",
  },
  {
    name: "Uganda",
    code: "UG",
    dialCode: "+256",
    flag: "🇺🇬",
  },
];

export const cleanPhoneNumber = (phoneNumberString: string) => {
  let cleaned = phoneNumberString.trim();

  // remove +234
  cleaned = cleaned.replace(/^\+234/, "");

  // remove braces, dashes and spaces
  cleaned = cleaned.replace(/-|\s|\(|\)/g, "");

  if (cleaned.startsWith("0")) {
    cleaned = cleaned.replace(/^0/, "");
  }

  return cleaned;
};

export const isValidText = (text: string) => {
  const cleaned = text.trim();

  if (cleaned.length === 0) {
    return false;
  }

  return true;
};

export const isValidPhoneNumber = (
  phoneNumberString: string,
  regex: RegExp = /^((70|71)|(80|81)|(90|91))\d{8}$/
) => {
  const cleaned = cleanPhoneNumber(phoneNumberString);

  // Check if the cleaned number is 10 digits long
  if (cleaned.length !== 10) {
    return false;
  }

  if (!regex.test(cleaned)) {
    return false;
  }

  // If it's not 10 digits long, it's not a number.
  return true;
};

export const schema = Joi.string().email({
  minDomainSegments: 2,
  tlds: { allow: false },
});

export const isValidEmail = (emailString: string) => {
  const { error } = schema.validate(emailString);

  if (error) {
    return false;
  }

  return true;
};
